import rebet from "./sounds/rebet.mp3"
import newBet from "./sounds/newbet.mp3"
import play from "./globals/playSFX.mp3"
import clear from "lib/audio/sounds/clear.mp3"

const clearSFX = new Audio(clear.default ? clear.default : clear)
const playSFX = new Audio(play.default ? play.default : play)
const rebetSFX = new Audio(rebet.default ? rebet.default : rebet)
const newBetSFX = new Audio(newBet.default ? newBet.default : newBet)

export default {
  playSFX,
  rebetSFX,
  newBetSFX,
  clearSFX,
}
